import RouterView from '../components/RouterView.vue'

import PartnerLectureListView from "../pages/partadmin/views/lecture/PartnerLectureListView.vue";
import PartnerLectureCreateView from "../pages/partadmin/views/lecture/PartnerLectureCreateView.vue";
import PartnerLectureDetailView from "../pages/partadmin/views/lecture/PartnerLectureDetailView.vue";
import PartnerLectureUpdateView from "../pages/partadmin/views/lecture/PartnerLectureUpdateView.vue";
import PartnerLectureCourseCreateView from "../pages/partadmin/views/lecture/PartnerLectureCourseCreateView.vue";

import PartnerLectureSurveyQuestionListView
    from "../pages/partadmin/views/lecture/survey/PartnerLectureSurveyQuestionListView.vue";
import PartnerLectureSurveyQuestionCreateView
    from "../pages/partadmin/views/lecture/survey/PartnerLectureSurveyQuestionCreateView.vue";
import PartnerLectureSurveyQuestionDetailView
    from "../pages/partadmin/views/lecture/survey/PartnerLectureSurveyQuestionDetailView.vue";

import PartnerLectureSurveyPaperListView
    from "../pages/partadmin/views/lecture/survey/PartnerLectureSurveyPaperListView.vue";
import PartnerLectureSurveyPaperCreateView
    from "../pages/partadmin/views/lecture/survey/PartnerLectureSurveyPaperCreateView.vue";
import PartnerLectureSurveyPaperDetailView
    from "../pages/partadmin/views/lecture/survey/PartnerLectureSurveyPaperDetailView.vue";

import PartnerLectureCourseListView from "../pages/partadmin/views/course/PartnerLectureCourseListView.vue";
import PartnerLectureCourseDetailView from "../pages/partadmin/views/course/PartnerLectureCourseDetailView.vue";

import SigninAdminView from '../pages/admin/views/signin/SigninView.vue'

export default [
    {
        path: '/partadmin',
        redirect: '/partadmin/signin',
        children: [
            {
                path: 'signin',
                name: 'SigninPartAdmin',
                component: SigninAdminView,
                meta: {
                    title: '관리자 로그인',
                }
            },


            {
                path: 'lecture',
                component: RouterView,
                meta: {
                    title: '강의 관리',
                    requiresAuth: true,
                    admin: true,
                    partadmin: true,
                },
                redirect: '/partadmin/lecture/manage',
                children: [
                    {
                        path: 'manage',
                        component: RouterView,
                        meta: {
                            title: '강의 목록',
                        },
                        children: [
                            {
                                path: '',
                                name: 'PartnerLectureList',
                                component: PartnerLectureListView,
                                meta: {
                                    title: '강의 목록',
                                }
                            },
                            {
                                path: 'create',
                                name: 'PartnerLectureCreate',
                                component: PartnerLectureCreateView,
                                meta: {
                                    title: '강의 등록',
                                }
                            },
                            {
                                path: 'course',
                                name: 'PartnerLectureCourseCreate',
                                component: PartnerLectureCourseCreateView,
                                meta: {
                                    title: '차시 등록',
                                }
                            },
                            {
                                path: 'detail/:id',
                                name: 'PartnerLectureDetail',
                                component: PartnerLectureDetailView,
                                meta: {
                                    title: '강의 상세',
                                }
                            },
                            {
                                path: 'update/:id',
                                name: 'PartnerLectureUpdate',
                                component: PartnerLectureUpdateView,
                                meta: {
                                    title: '강의 수정',
                                }
                            },
                        ]
                    },
                    {
                        path: 'survey',
                        component: RouterView,
                        meta: {
                            title: '만족도 평가',
                        },
                        redirect: '/partadmin/lecture/survey/surveyQuestion',
                        children: [
                            {
                                path: 'surveyQuestion',
                                component: RouterView,
                                meta: {
                                    title: '문항 관리',
                                },
                                children: [
                                    {
                                        path: '',
                                        name: 'PartnerLectureSurveyQuestionList',
                                        component: PartnerLectureSurveyQuestionListView,
                                        meta: {
                                            title: '문항 관리',
                                        }
                                    },
                                    {
                                        path: 'create/:id',
                                        name: 'PartnerLectureSurveyQuestionCreate',
                                        component: PartnerLectureSurveyQuestionCreateView,
                                        meta: {
                                            title: '문항 등록하기',
                                        }
                                    },
                                    {
                                        path: 'detail/:id',
                                        name: 'PartnerLectureSurveyQuestionDetail',
                                        component: PartnerLectureSurveyQuestionDetailView,
                                        meta: {
                                            title: '문항 상세',
                                        }
                                    },
                                ],
                            },
                            {
                                path: 'surveyPaper',
                                component: RouterView,
                                meta: {
                                    title: '평가 관리',
                                },
                                children: [
                                    {
                                        path: '',
                                        name: 'PartnerLectureSurveyPaperList',
                                        component: PartnerLectureSurveyPaperListView,
                                        meta: {
                                            title: '평가 관리',
                                        }
                                    },
                                    {
                                        path: 'create/:id',
                                        name: 'PartnerLectureSurveyPaperCreate',
                                        component: PartnerLectureSurveyPaperCreateView,
                                        meta: {
                                            title: '평가 등록하기',
                                        }
                                    },
                                    {
                                        path: 'detail/:id',
                                        name: 'PartnerLectureSurveyPaperDetail',
                                        component: PartnerLectureSurveyPaperDetailView,
                                        meta: {
                                            title: '평가 관리 상세 ',
                                        }
                                    }
                                ]
                            },
                        ]
                    },
                ]
            },
            {
                path: 'course',
                component: RouterView,
                meta: {
                    title: '수강 관리',
                    requiresAuth: true,
                    admin: true,
                    partadmin: true,
                },
                children: [
                    {
                        path: '',
                        name: 'PartnerLectureCourseList',
                        component: PartnerLectureCourseListView,
                        meta: {
                            title: '수강 관리',
                        }
                    },
                    {
                        path: ':id',
                        name: 'PartnerLectureCourseDetail',
                        component: PartnerLectureCourseDetailView,
                        meta: {
                            title: '수강 관리',
                        }
                    },
                ]
            },








        ]
    },
]